import makeStyles from "@mui/styles/makeStyles";
import type { ClassNameMap, Styles, WithStylesOptions } from "@mui/styles/withStyles";

import { type EroadTheme, eroadTheme } from "../theme/eroadTheme";

/**
 * This is a copied implementation of makeStyles from mui as it is using makeStyles directly.
 * The small difference is that it accepts both a callback and object with styles (line 14-18)
 */
function makeEroadStyles<Props extends object = object, Theme = EroadTheme, ClassKey extends string = string>(
  stylesOrCreator: Styles<Theme, Props, ClassKey>,
  options?: Omit<WithStylesOptions<Theme>, "withTheme">
): keyof Props extends never ? (props?: any) => ClassNameMap<ClassKey> : (props: Props) => ClassNameMap<ClassKey> {
  let makeStylesOptions = options;

  /**
   * This is to set default `theme` for jest tests to not mock the ThemeProvider.
   * To detect if it's a test run, we check if `process.env.NODE_ENV` is "test".
   *
   * But also, for antd's `message` static methods as they are used incorrectly (they don't have access to context or our theme)
   * Please refer to https://ant.design/components/message > "Hooks usage (recommended)" example
   */
  makeStylesOptions = {
    ...options,
    defaultTheme: eroadTheme as Theme,
  };

  if (typeof stylesOrCreator === "function") {
    return makeStyles<Theme, Props, ClassKey>((theme) => stylesOrCreator(theme), makeStylesOptions);
  }

  return makeStyles<Theme, Props, ClassKey>(stylesOrCreator, makeStylesOptions);
}

export { makeEroadStyles };
